/*
 * @Author: Zhouqi
 * @Date: 2025-10-30 16:45:25
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-12-24 15:35:42
 */
import Image from 'next/image';
import { useRouter } from 'next/router';
import * as React from 'react';

import { homeURL } from '@/utils/router';

const LogoIcon: React.FC<React.SVGProps<SVGElement>> = () => {
  const router = useRouter();

  const handleLogoClick = () => {
    router.push(homeURL);
  };
  return (
    <div
      className="flex items-center shrink-0 gap-[8px] self-center h-[56px] cursor-pointer fixed top-0 z-10 w-[221px] bg-[#fff]"
      onClick={handleLogoClick}
    >
      <Image
        className="ml-[25px]"
        src="/images/logo-with-name.png"
        alt="logo"
        width={120}
        height={30}
        fetchPriority="high"
      />
    </div>
  );
};

export default React.memo(LogoIcon);
